import { useMemo } from 'react';
import classnames from 'classnames/bind';
import { isEmpty } from 'lodash';
import { KeyboardArrowRightIcon } from 'tuui';
import { useElementSize } from 'taboola-ultimate-ui';
import { useBreadcrumbsPickerData } from './hooks/useBreadcrumbsPickerData';
import styles from './AppBreadcrumbs.module.scss';

const classNameBuilder = classnames.bind(styles);

export const AppBreadcrumbs = ({ accountSelectionAllowed = true, hidden }) => {
    const { width, ref: containerRef } = useElementSize();
    const pickersData = useBreadcrumbsPickerData({ accountSelectionAllowed });
    const pickersDataWithDivider = useMemo(() => {
        const result = pickersData.reduce((acc, { id, component: Component, componentProps }, index) => {
            const itemContent = {
                id,
                content: <Component {...componentProps} mainContainerWidth={width} />,
                picker: true,
            };
            if (index === pickersData.length - 1) {
                return [...acc, itemContent];
            }
            return [...acc, itemContent, { content: <KeyboardArrowRightIcon className={styles['icon']} /> }];
        }, []);

        return result;
    }, [pickersData, width]);

    if (isEmpty(pickersData)) {
        return null;
    }

    return (
        <div className={classNameBuilder('container', { hidden })} ref={containerRef}>
            {pickersDataWithDivider.map(({ id, content, picker }, index) => (
                <div key={id || index} className={classNameBuilder('item', { picker })}>
                    {content}
                </div>
            ))}
        </div>
    );
};
